import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import Collapse from '@mui/material/Collapse'
import List from '@mui/material/List'
import MenuItem from '@mui/material/MenuItem'
import { styled, Theme } from '@mui/material/styles'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import { useTranslate } from 'react-admin'
import { border, xxllncColor } from './themes'
import { FC } from 'react'

const SubMenu: FC<Props> = (props: Props) => {
  const translate = useTranslate()
  const {
    handleToggle,
    sidebarIsOpen,
    isOpen,
    name,
    children,
    dense
  } = props

  const header = (
    <MenuItem className={classes.header} dense={dense} onClick={handleToggle}>
      <Typography variant="inherit" className={classes.title}>
        {translate(name)}
      </Typography>
      <div className={classes.dropdown}>
        {isOpen ? <ExpandLess /> : <ExpandMore />}
      </div>
    </MenuItem>
  )

  return children ? (
    <Root className={classes.root} {...props}>
      {sidebarIsOpen || isOpen ? (
        header
      ) : (
        <Tooltip title={translate(name)} placement="right">
          {header}
        </Tooltip>
      )}
      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <List
          dense={dense}
          component="div"
          disablePadding
          className={
            sidebarIsOpen
              ? classes.sidebarIsOpen
              : classes.sidebarIsClosed
          }
        >
          {children}
        </List>
      </Collapse>
    </Root>
  ) : null
}

interface Props {
  dense: boolean;
  handleToggle: () => void;
  isOpen: boolean;
  name: string;
  sidebarIsOpen: boolean;
  children?: React.ReactNode;
}

interface StyleProps {
  isOpen?: boolean;
  sidebarIsOpen?: boolean;
}

const PREFIX = 'xxllncSubMenu'

const classes = {
  root: `${PREFIX}-root`,
  header: `${PREFIX}-header`,
  title: `${PREFIX}-title`,
  dropdown: `${PREFIX}-dropdown`,
  sidebarIsOpen: `${PREFIX}-sidebarIsOpen`,
  sidebarIsClosed: `${PREFIX}-sidebarIsClosed`,
}

const Root = styled('div')(({ theme, isOpen, sidebarIsOpen }: StyleProps & { theme: Theme }) => ({
  [`&.${classes.root}`]: {
    overflow: 'hidden',
    ['& .MuiList-root']: {
      paddingLeft: theme.spacing(.5),
      paddingRight: theme.spacing(.5),
      paddingBottom: theme.spacing(.5),
      ['& .MuiListItem-button']: {
        padding: sidebarIsOpen ? theme.spacing(2).toString() + ' !important' : '9px !important',
      },
    },
    ['& .MuiMenuItem-root']: {
      padding: '12px 20px',
    },
    ['& .MuiSvgIcon-root']: {
      fill: xxllncColor.light100,
    },
  },
  [`& .${classes.header}`]: {
    borderRadius: border.radius.md,
    display: 'flex',
    height: '48px !important',
    paddingLeft: sidebarIsOpen ? theme.spacing(2) : theme.spacing(1.5),
    paddingRight: sidebarIsOpen ? theme.spacing(2) : theme.spacing(1.5),
    marginTop: '0px !important',
    marginBottom: isOpen ? theme.spacing(1.5) : 0,
    ['&:hover']: {
      [theme.breakpoints.up('sm')]: {
        backgroundColor: xxllncColor.dark100,
      }
    }
  },
  [`& .${classes.title}`]: {
    [theme.breakpoints.up('sm')]: {
      color: xxllncColor.light100,
    }
  },
  [`& .${classes.dropdown}`]: {
    display: 'flex',
    marginLeft: 'auto',
  },
  [`& .${classes.sidebarIsOpen}`]: {
    ['& a']: {
      transition: 'padding-left 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms',
    },
  },
  [`& .${classes.sidebarIsClosed}`]: {
    ['& a']: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      transition: 'padding-left 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms',
    },
  },
}))

export default SubMenu
